export default "__VITE_ASSET__CA8waHiT__"